module.exports = __webpack_public_path__ + "img/蜜.2f731d74.png";